module.exports = __webpack_public_path__ + "assets/img/detail-btn-adedf837.png";